import React from 'react';
import { usePlannerConfig } from 'contexts/plannerConfig';
import { Feature, RenderLocation, RendersComponent } from 'features/Feature';
import { FeatureConfig } from 'rangeConfig/@types';

export const getFeatureComponents = (features: FeatureConfig[], renderLocation: RenderLocation) =>
  features
    .map(f => f.feature)
    .filter(feature => 'render' in feature)
    .map(f => (f as Feature & RendersComponent).render(renderLocation))
    .filter(Boolean) as NonNullable<ReturnType<RendersComponent['render']>>[];

type FeaturesProps = {
  location?: RenderLocation;
};

const Features = ({ location }: FeaturesProps) => {
  const {
    plannerConfig: { features }
  } = usePlannerConfig();

  return getFeatureComponents(features, location ?? RenderLocation.Root).map(
    (Component, i) => Component && <Component key={i} />
  );
};

export default Features;
